var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon__pause--system icon--style--fill icon--size--small",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8 0a8 8 0 108 8 8 8 0 00-8-8zM7 10.75a.75.75 0 11-1.5 0v-5.5a.75.75 0 011.5 0zm3.5 0a.75.75 0 01-1.5 0v-5.5a.75.75 0 011.5 0z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }